module.exports = __webpack_public_path__ + "images/653ce74869b1fded4829505e86a38a76-Australia.png";